import { render, staticRenderFns } from "./Licenca.vue?vue&type=template&id=752941e8"
import script from "./Licenca.vue?vue&type=script&lang=js"
export * from "./Licenca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports